// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { DefaultEnvironment } from './environment.def';

// Included with Angular CLI.
import 'zone.js/dist/zone-error';
import { environment as localEnvironment } from './environment.local';

export const environment = Object.assign<DefaultEnvironment, DefaultEnvironment, DefaultEnvironment>(new DefaultEnvironment(), {
    production: false,
    apiUrl: '',
    socketUrl: '',
    systemState: 'Seattle',
    mode: 'dev',
    systemSeattleUrl: '',
    systemCaliforniaUrl: '',
  systemCartTvUrl: ''
}, localEnvironment)

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
